module.exports = __webpack_public_path__ + "static/media/BG_70.17ca0ded.png";